import { Card, Row, Col, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { HelpSystemCard } from '../../config/helpPage.config';
import { gaisukePublicPath } from '../../utils/gaisukePath';
import { laboSukePublicPath } from '../../utils/laboSukePath';

interface HelpSystemIndexProps {
  cards: HelpSystemCard[];
}

function resolveHelpCardPath(card: HelpSystemCard, locale: string): string {
  if (card.id === 'labo_suke') return laboSukePublicPath(locale);
  if (card.id === 'gaisuke') return gaisukePublicPath(locale);
  return card.path;
}

export default function HelpSystemIndex({ cards }: HelpSystemIndexProps) {
  const { t, i18n } = useTranslation();

  return (
    <Row className="g-3">
      {cards.map((card) => (
        <Col md={6} lg={4} key={card.id}>
          <Card className="h-100 shadow-sm">
            <Card.Body className="d-flex flex-column">
              <div className="d-flex align-items-start justify-content-between mb-2">
                <Card.Title className="h6 mb-0">
                  <i className={`fas ${card.icon} ${card.iconColor ?? 'text-primary'} me-2`} />
                  {t(card.titleKey)}
                </Card.Title>
                <div className="d-flex flex-column gap-1 align-items-end">
                  {card.loginRequired && (
                    <Badge bg="secondary" className="text-nowrap">
                      {t('help.login_required')}
                    </Badge>
                  )}
                  {card.adminOnly && (
                    <Badge bg="warning" text="dark" className="text-nowrap">
                      {t('help.admin_only')}
                    </Badge>
                  )}
                </div>
              </div>
              <Card.Text className="text-muted small flex-grow-1">{t(card.descKey)}</Card.Text>
              <Link
                to={resolveHelpCardPath(card, i18n.language)}
                className="btn btn-outline-primary btn-sm mt-2 align-self-start"
              >
                {t(card.linkKey)}
              </Link>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}
